import React, { useEffect, useImperativeHandle, useState } from "react";
import { Button, Input } from "../Elements";
import Modal from "../Modal";
import { toast } from "react-toastify";
import commonNetwork from "../../../common/api/commonNetwork";
import Loading from "../Loading";
type FormProps = {
    apiKey: string,
    apiVersion: string,
    hotelId: string,
    id:number
}
type Props = { 
    setConfigurationMissing: (isMissing: boolean)=>void
}
export type SabeeAppIntegrationModalRefProps = {
    openModal: () => void
}

const SabeeAppIntegrationModal = React.forwardRef<SabeeAppIntegrationModalRefProps, Props>((props: Props, ref) => {
 
    const [isModalVisible, setIsModalVisible] = useState(false);  
    const[getLoading, setGetLoading] = useState(true);
    const [fields, setFields] = useState<FormProps>({
        apiKey: "",
        apiVersion: "1",
        hotelId: "",
        id:0
    });

    const [createLoading, setCreateLoading] = useState(false);

    useImperativeHandle(ref, () => ({

        openModal() {
            onOpenModalClick();
        }

    }));

    useEffect(()=>{
        selectSabeeAppInformations();
    },[]);
    const selectSabeeAppInformations =async()=>{

        const {data, errorMessage, isSuccess} = await commonNetwork.get("/sabeeapp/get-config");
        setFields(data);
        if (!data.hotelId ||  data.apiKey?.length == 0 || !data.apiVersion) {
            props.setConfigurationMissing(true);
        }
        setGetLoading(false);

    }
    const onOpenModalClick = () => {
        setIsModalVisible(true);

    }

    const onPostClick = () => {
        if (fields.apiKey?.length == 0) {
            toast.error("Lütfen geçerli bir Api Key giriniz.");
            return;
        } else
            if (fields.hotelId?.length == 0) {
                toast.error("Lütfen geçerli bir Hotel Id giriniz.");
                return;
            } else {
                onPost();
            }
    }
   

    const onPost = async () => {
        
        const params = fields
        setCreateLoading(true);
        const response = await commonNetwork.post("/sabeeapp/post-config", params);

        const { isSuccess, data, errorMessage } = response;
        setCreateLoading(false);
        if (isSuccess) {
 

            setIsModalVisible(false);
            props.setConfigurationMissing(false);
            toast.success("SabeeApp entegrasyon bilgileri başarılı bir şekilde kaydedildi.");

        } else {
            toast.error(errorMessage);
        }

    }

    const onChangeField = (event: any) => {


        setFields({
            ...fields,
            [event.target.name]: event.target.value
        });
    }

  
    return (
        <>
            <Modal openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} >
                <div>
                    <div className="sm:flex sm:items-start mv">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-[100%]">
                            <h3 className="text-xl leading-6 font-medium text-gray-900">
                                SabeeApp Entegrasyon Bilgileri

                            </h3>
                            <div className="flex w-100">
                                <div className="flex-auto w-50 mb-6">
                                {getLoading ?(
                                    <Loading desc="Entegrasyon bilgileri yükleniyor..." />
                                ) :(
                                    <>
                                    
                                    <div className="mt-4">
                                        <Input
                                            name={`apiKey`}
                                            value={fields.apiKey}
                                            className="w-[100%]"
                                            label="Api Key"
                                            onChange={onChangeField}
                                            required
                                            type="text"
                                            maxLength={150}
                                        />
                                    </div>
                                    <div className="mt-4">
                                        <Input
                                            name={`apiVersion`}
                                            value={fields.apiVersion}
                                            type="text"
                                            className="w-[100%]"
                                            label="Api Version"
                                            onChange={onChangeField} 
                                            maxLength={10}
                                        />
                                    </div>
                                    <div className="mt-4">
                                        <Input
                                            name={`hotelId`}
                                            value={fields.hotelId}
                                            type="text"
                                            className="w-[100%]"
                                            label="Hotel Id"
                                            onChange={onChangeField}
                                            required 
                                            maxLength={50}
                                        />
                                    </div>
                                    </>
                                )}



                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 mt-4 flex justify-end space-x-2">
                        <Button
                            color="gray"
                            hover="gray"
                            size="xs"
                            disabled={getLoading || createLoading}
                            loading={createLoading}
                            callback={() => setIsModalVisible(false)}
                        >
                            İptal
                        </Button>
                        <Button
                            color="primary"
                            hover="primary"
                            size="xs"
                            loading={createLoading}
                            disabled={createLoading}
                            callback={onPostClick}
                        >
                            Gönder
                        </Button>
                    </div>
                </div>
            </Modal>

        </>
    );
})

export default SabeeAppIntegrationModal;